/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.AuditChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './AuditChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.AuditChirpService#get
 */
export const GET_QUERY_FIELD_NAME = 'com_hubspot_learning_center_playlists_rpc_AuditChirpService_get';
export const GET_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_QUERY_FIELD_NAME,
  args: ['playlistId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});